import styled from "styled-components";

export const AcountSettingsTableWrapper = styled.div`
	margin-bottom: 2em;
`;
